import React from 'react';
import { createPortal } from 'react-dom';

interface DisabledUserModalProps {
  open: boolean;
  /** Ends the session — triggered by both the Logout button and the X. */
  onLogout: () => void;
}

// Modal shown when the current user has been disabled. Cannot be dismissed by
// clicking outside; both the Logout button and the X end the session.
const DisabledUserModal: React.FC<DisabledUserModalProps> = ({ open, onLogout }) =>
{
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[10005] flex items-center justify-center">
      {/* Backdrop has no onClick — cannot be dismissed by clicking outside */}
      <div className="fixed inset-0 bg-black/40" />
      <div className="relative z-10 bg-white rounded shadow-xl p-6 w-[400px]">
        <h3 className="static text-xl text-[#4887be] text-[21px] leading-[21px] font-sans font-medium">
          Disabled user
        </h3>
        <div
          className="icon-incorrect-icon text-brightGray text-[14px] absolute right-[18px] top-5 cursor-pointer p-2"
          onClick={onLogout}
        />
        <p className="text-[13px] text-[#555] mt-3 mb-5">Your user has been disabled</p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onLogout}
            className="px-4 py-1.5 text-[12px] bg-[#62aacb] text-white rounded hover:bg-[#4e99ba]"
          >
            Logout
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DisabledUserModal;
